import { useEffect, useMemo } from 'react';
import {
  getRefetchIntervalForTransactionsFromJackpotsProbability,
  openJackpotModalFromBonusesTransactions,
  openJackpotModalFromTransactions
} from '../utils/jackpotModalUtils';
import { useGetBonusesTransactions, useGetJackpots, useGetTransactions } from 'react-easyrocket';
import { useModalContext } from 'src/hooks/useModalContext';

export const useJackpotWin = () => {
  const { openModal } = useModalContext();
  const { jackpots } = useGetJackpots({}, { refetchInterval: 5000 });

  const bonusesRefetchInterval = useMemo(
    () => getRefetchIntervalForTransactionsFromJackpotsProbability(jackpots),
    [jackpots]
  );
  const { arrayBonusesTransactions } = useGetBonusesTransactions(
    {
      bonus_type: 'All',
      status: ['Pending'],
      type: ['JackpotWin']
    },
    {
      isNeedPages: false,
      refetchInterval: bonusesRefetchInterval
    }
  );
  const { transactions } = useGetTransactions(
    {
      type: ['Jackpot']
    },
    { refetchInterval: bonusesRefetchInterval, target: 'type jackpot' }
  );

  useEffect(() => {
    openJackpotModalFromTransactions(transactions?.transactions, (jackpot) => {
      openModal('JACKPOT_WIN', {
        props: { jackpot }
      });
    });
    openJackpotModalFromBonusesTransactions(arrayBonusesTransactions, (jackpot) => {
      openModal('JACKPOT_WIN', {
        props: { jackpot }
      });
    });
  }, [arrayBonusesTransactions, transactions, openModal]);
};
